// extracted by mini-css-extract-plugin
module.exports = {"root":"dropdownMenu_root__3Amuc","toggle":"dropdownMenu_toggle__zc11Y","options":"dropdownMenu_options__3_QV9","option":"dropdownMenu_option__3X0wX"};